import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { RedepositoChequeService } from 'src/app/services/redeposito-cheque.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { XLS_URL } from 'src/environments/environment';
import { ModalAddEditRedepositoComponent } from '../modal-add-edit-redeposito/modal-add-edit-redeposito.component';
import * as _ from 'lodash'
import { FileDownloadService } from 'src/app/shared/services/file-download.service';

@Component({
  selector: 'app-cheques-redeposito-detalles',
  templateUrl: './detalles.component.html',
  styleUrls: ['./detalles.component.scss'],
  providers: [SecurityService]
})
export class DetallesComponent implements OnInit {

  // Modales
  @ViewChild(ModalAddEditRedepositoComponent, { static: true }) modalRedeposito: ModalAddEditRedepositoComponent

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  loadAll: boolean = false
  listaRedepositos: any = null
  inputParams: any = null
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = false
  loaded: boolean = false

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private rutService: RutService,
    private messageRendererService: MessageRendererService,
    private redepositoChequeService: RedepositoChequeService,
    private fileDownloadService: FileDownloadService
  ) {
    this.log = this.clog.log('INVENTARIO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())

    this.paginationContext.RecordsByPage = 10
  }

  loadData({ rutCliente, fechaDesde, fechaHasta }) {
    this.listaRedepositos = null
    this.paginationContext.CurrentPage = 1
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        cliente_proveedor_rut: this.rutService.QuitarDV(rutCliente),
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta
      },
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
    this.inputParams = inputParams
    this.loadAll = false
    this.buscar()
  }

  loadAllData() {
    this.listaRedepositos = null
    this.paginationContext.CurrentPage = 1
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa
      },
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
    this.inputParams = inputParams
    this.loadAll = true
    this.buscar()
  }

  buscar() {
    this.inputParams.paginaActual = this.paginationContext.CurrentPage

    if (this.loadAll) {
      this.redepositoChequeService.obtenerTodosRedeposito(this.inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          return
        }

        this.renderResults(respuesta)
      })
    } else {
      this.redepositoChequeService.obtenerSegunFiltro(this.inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          return
        }

        this.renderResults(respuesta)
      })
    }
  }

  renderResults({ registros, paginaActual, totalPaginas, totalRegistros }) {
    this.paginationContext.RecordsCount = totalRegistros
    this.paginationContext.CurrentPage = paginaActual
    this.paginationContext.PagesCount = totalPaginas
    this.listaRedepositos = registros
    this.listaRedepositos.map(item => {
      item.cliente_proveedor_rutFormato = this.rutService.AgregarDV(item.cliente_proveedor_rut)
    })
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage
    this.buscar()
  }

  openModalRedeposito() {
    this.modalRedeposito.show()
  }

  loadModalRedeposito(codigo) {
    this.modalRedeposito.loadAndShow(codigo)
  }

  downloadExcel() {
    const inputParams = _.cloneDeep(this.inputParams)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    this.redepositoChequeService.obtenerExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.rutaArchivo)
    })
  }

}
